import { Box, Button, Typography } from '@mui/material';
import { useWizard } from 'react-use-wizard';

export function WizardFooter() {
  // Footer is hidden, no buttons needed
  return null;
}
